//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      tableData:[],
      dialogState:false,
      initSupplier:'选择供应商',
      dealerList:[
      ],
      goodsList:[
      ],
      goodsListKey:[],
      copyGoodsList:[],
      copyInitSupplier:'',
      goodsHeader:[],
      pageInfoData: {}
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(){
      this.tableData = []
      this.$axios.get('/mtea/stock/shopping/getDealerGoodsList',{params:{sysShopId:this.$route.query.shopId}}).then(res=>{
        this.tableData = res
      })
    },
    pageInfo(data){
      this.goodsList = []
      this.copyGoodsList = []
      this.goodsHeader =[]
      this.$axios.get('/mtea/stock/shopping/getDealerBindList',{params:data}).then(res=>{
        this.copyGoodsList = JSON.stringify(res.goodsList)
        this.goodsList = res.goodsList
        this.dealerList =res.dealerList
        for (const key in this.goodsList) {
          this.goodsHeader[key] = false
        }
        this.infoGoodsList(true)
      })
    },
    infoGoodsList( dealerMoneyState = false){
      for(let key in this.goodsList){
        let state = true
        this.goodsList[key].forEach(sub => {
          if(dealerMoneyState){
            if(sub.dealerMoney){
              sub.dealerMoney = sub.dealerMoney / 100
            }else{sub.dealerMoney = null}
          }
          if(sub.dealerStatus===2){
            sub.state = true
          }else{
            sub.state = false
          }
          if(!sub.state) state = false
          if(sub.dealerId){
            sub.shopName = ''
            this.dealerList.forEach(shop=>{
              if(shop.dealerId === sub.dealerId && sub.shopName === ''){
                sub.shopName = shop.name                  
              }
            })
          }
          this.goodsHeader[key] = state
        });
      };
      let data = JSON.stringify(this.goodsList)
      this.goodsList = []
      this.pageInfoData = JSON.parse(data)
      this.goodsList = JSON.parse(data)
      // this.$set(this.goodsList)
    },
    dealerChange(row){
      let flag = true
      let goodsListRes = JSON.parse(this.copyGoodsList)
      for(let key in this.goodsList){
        for(let subKey in this.goodsList[key]){
          if(this.goodsList[key][subKey].dealerStatus !== goodsListRes[key][subKey].dealerStatus){
            flag = false
          }
        }
      }
      if(!flag){
        this.$message({
          message: '请先保存已修改的信息',
          type: 'warning'
        });
        this.initSupplier = this.copyInitSupplier
        return
      }
      this.pageInfo({sysShopId:this.$route.query.shopId,dealerId:row})
      this.copyInitSupplier = this.initSupplier = row
    },
    refresh(){
      this.dialogState = true
      this.initSupplier = '选择供应商'
      this.pageInfo({sysShopId:this.$route.query.shopId})
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
    handleClick(row){
      this.dialogState = true
      this.pageInfo({sysShopId:this.$route.query.shopId,dealerId:row.dealerId})
      this.initSupplier = row.dealerId
      this.copyInitSupplier = row.dealerId
    },
    checkAll(key){
      let headerList = {}
      for (const i in this.goodsList) {
        headerList[i] = this.goodsHeader[i]
        if(i === key){
          headerList[i] = !this.goodsHeader[i]
        }
      }
      headerList[key] = !headerList[key]
      this.goodsHeader = headerList
      for (const keySub in this.goodsList[key]) {
        if(this.goodsHeader[key]){
          this.goodsList[key][keySub].dealerStatus = 2
          this.goodsList[key][keySub].dealerId = this.initSupplier
        }else{
          this.goodsList[key][keySub].dealerStatus = 0
          delete this.goodsList[key][keySub].dealerId
          delete this.goodsList[key][keySub].shopName
        }
      }
      this.infoGoodsList()
    },
    selectGoods(i,subI){
      let goodsListRes = JSON.parse(this.copyGoodsList)
      // //0 可选1 被其他供应商选了 2 已选
      if(this.goodsList[i][subI].state === true && this.goodsList[i][subI].dealerStatus === 0){          // 选择未选
        this.goodsList[i][subI].dealerStatus = 2
        this.goodsList[i][subI].dealerId = this.initSupplier
      }else if(this.goodsList[i][subI].state === true && this.goodsList[i][subI].dealerStatus === 1){    // 选择被其他选择
        this.goodsList[i][subI].dealerStatus = 2
        this.goodsList[i][subI].dealerId = this.initSupplier
      }else if(this.goodsList[i][subI].state === false && this.goodsList[i][subI].dealerStatus === 2 && goodsListRes[i][subI].dealerStatus !== 2){   // 取消已选，原本已选择
        this.goodsList[i][subI] = goodsListRes[i][subI]
      }else if(this.goodsList[i][subI].state === false && this.goodsList[i][subI].dealerStatus === 2 && goodsListRes[i][subI].dealerStatus === 2){   // 取消已选，选择后再取消
        this.goodsList[i][subI].dealerStatus = 0
        delete this.goodsList[i][subI].dealerId
        delete this.goodsList[i][subI].shopName
      }else{
        console.warn('else被执行')
      }
      this.infoGoodsList()
    },
    preserve(){
      let dataList = []
      let goodsListRes = JSON.parse(this.copyGoodsList)
      for(let key in this.goodsList){
        for(let keySub in this.goodsList[key]){
          let data = {}
          //0 可选1 被其他供应商选了 2 已选                                                     
          if((this.goodsList[key][keySub].dealerStatus !== goodsListRes[key][keySub].dealerStatus &&
          // (全选后取消全选导致的商品不能加入到已经改变的内容中)
          !(this.goodsList[key][keySub].dealerStatus === 0 && goodsListRes[key][keySub].dealerStatus === 1)) ||
          ( this.goodsList[key][keySub].dealerMoney !== null && this.goodsList[key][keySub].dealerMoney * 100 !== goodsListRes[key][keySub].dealerMoney)
          ){
            //原价没有变，修改的价格不为空就不传，后端要求不传即原来价格
            // if(this.goodsList[key][keySub].goodsPrice === goodsListRes[key][keySub].goodsPrice){
            //   if(this.goodsList[key][keySub].dealerMoney !== ''){
            //     data.dealerMoney = this.goodsList[key][keySub].dealerMoney
            //   }
            // }else{
            //   data.dealerMoney = this.goodsList[key][keySub].goodsPrice
            // }
            if(this.goodsList[key][keySub].dealerMoney > 0 ){
              data.dealerMoney = this.goodsList[key][keySub].dealerMoney * 100
            }
            if(this.goodsList[key][keySub].dealerStatus===2){
              data.sysGoodsId = this.goodsList[key][keySub].goodsId
              data.status = 0
              data.dealerId = this.goodsList[key][keySub].dealerId
            }else if(this.goodsList[key][keySub].dealerStatus===1){
              data.sysGoodsId = this.goodsList[key][keySub].goodsId
              data.status = 0
              data.dealerId = this.goodsList[key][keySub].dealerId
            }else{
              data.sysGoodsId = this.goodsList[key][keySub].goodsId
              data.status = -1
            }
          }
          if(Object.keys(data).length>0)
          dataList.push(data)
        }
      }
      if(dataList.length===0){
        this.$message({
          message: '请先修改信息',
          type: 'warning'
        });
        return
      }
      dataList = JSON.stringify(dataList)
      this.$axios.post('/mtea/stock/shopping/doBindDealer',{bindJson:dataList}).then(res=>{
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.dialogState = false
        this.info()
      })
    },
    inputAlter(val){
      let char = val.dealerMoney[val.dealerMoney.length-1]
      if ( 
        char === '0'||
        char === '1'||
        char === '2'||
        char === '3'||
        char === '4'||
        char === '5'||
        char === '6'||
        char === '7'||
        char === '8'||
        char === '9'
      ){
        if (char !== '0' && val.dealerMoney[val.dealerMoney.length-2] !== '.') {
          val.dealerMoney = (Math.floor(val.dealerMoney*100))/100
        }
      } else if (char === '.') {
        if (val.dealerMoney.indexOf('.') !== val.dealerMoney.length-1) {
          val.dealerMoney = val.dealerMoney.slice(0,val.dealerMoney.length-1)
        }
      } else {
        val.dealerMoney = val.dealerMoney.replace(char,'')
      }
      if (isNaN(val.dealerMoney)) val.dealerMoney = null
    }
  }
}
